import request from ".";

export const centersApi = {
  getCenter: (center: string) =>
    request.post(`Center/getCenterByUrl?UniqueUrl=${center}`),
};
